import { render, staticRenderFns } from "./ListReportBpjstk.vue?vue&type=template&id=5854d97a"
import script from "./ListReportBpjstk.vue?vue&type=script&lang=js"
export * from "./ListReportBpjstk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports